import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { uuid } from "@/interfaces";
import { createServiceSurvey, deleteServiceSurvey, getServiceSurveys } from "./survey.slice";
import { SurveyQuestionDraft } from "@/models/survey.model";
import { toastError, toastSuccess } from "@/lib/utils";

export function useServiceSurveys(id: uuid) {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const { list, loading } = useAppSelector((state) => state.surveys);

  function load() {
    dispatch(getServiceSurveys(id))
      .unwrap()
      .catch(() => toastError("The survey questions could not be loaded."));
  }

  async function onSubmit(draft: SurveyQuestionDraft) {
    try {
      await dispatch(createServiceSurvey({ service: id, draft })).unwrap();
      toastSuccess("Survey questions successfully added.");
      setOpen(false);
    } catch {
      toastError("There was something wrong while adding survey questions.");
    }
  }

  async function onDelete(question: uuid) {
    try {
      await dispatch(deleteServiceSurvey({ service: id, question })).unwrap();
      toastSuccess("Survey questions successfully deleted.");
    } catch {
      toastError("There was something wrong while deleting survey questions.");
    }
  }

  useEffect(() => {
    load();
  }, [id]);

  return {
    list,
    loading,
    open,
    setOpen,
    onSubmit,
    onDelete,
  };
}
